<template lang="pug">
  #main-app
    router-view(v-slot="{ Component }")
      transition(name="fade")
        component(:is="Component")
</template>

<script>
  export default {
    name: "App",
  }
</script>

<style lang="sass" src="./styles/application.sass"></style>
